<script>
  import { tick } from 'svelte';
  import BaseHeading from '../BaseHeading/BaseHeading.svelte';
  import PharmacyLocationAction from '../PharmacyLocationAction/PharmacyLocationAction.svelte';
  import FilterTabs from '../FilterTabs/FilterTabs.svelte';
  import PaginationControl from '../PaginationControl/PaginationControl.svelte';

  let {
    headingTextTemplate,
    headingLevel,
    descriptionTemplate,
    paginationControl,
    filterTabs,
    dataTestId = 'pharmacy-locations',
    pharmacies,
    fullWidth = false
  } = $props();

  let initialStates = {
    initializing: false,
  };

  let currentState = $state();

  const setState = (state) => {
    currentState = { ...initialStates, [state]: true };
  };

  setState('initializing');

  $effect(() => {
		tick().then(() => {
      if (pharmacies) {
        setState('idle');
      }
		});
  });
</script>

<section class="grow" data-testid={dataTestId} class:mx-auto={fullWidth} class:max-w-6xl={fullWidth}>
  {#if pharmacies.length}
    <div class="mb-4 px-4 lg:mb-6">
      <BaseHeading {headingLevel} className="text-blue-dark-navy font-semibold text-lg lg:text-1.5xl leading-tight mb-2">
        {headingTextTemplate}
      </BaseHeading>
      {#if descriptionTemplate}
        {@html descriptionTemplate}
      {/if}
    </div>
    {#if filterTabs}
      <FilterTabs {...filterTabs} className="md:mx-4" />
    {/if}
    <div
      class="px-4 py-3 grid gap-4 mb-6 sm:grid-cols-2 lg:py-0"
      class:lg:grid-cols-3={fullWidth}
      class:lg:gap-6={fullWidth}
    >
      {#each pharmacies as { name, phone, lat, lng, address: { addressLine1, addressLine2, city, state, zip }, distance, open, url, onClick }, index (index)}
        <PharmacyLocationAction
          {currentState}
          {name}
          {addressLine1}
          {addressLine2}
          {city}
          {state}
          {zip}
          {distance}
          {lat}
          {lng}
          {url}
          {phone}
          {open}
          alt={name}
          {onClick}
          lazyloadImage={index > 1}
        />
      {/each}
    </div>
    {#if paginationControl}
      <div class="max-w-56 mx-auto pb-4">
        <PaginationControl {...paginationControl} />
      </div>
    {/if}
  {/if}
</section>
